import React, { useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import Loader from '../Loader/Loader';
import Graph3D from './Graph/3DGraph';
import Filter3D from './Filter/3DFilter';
import getNewRoute from '../../containers/helpers';

import Filters from '../FiltersSet/Filters';
import Card from '../Card/Card';
import ViewTitle from '../ViewTitle/ViewTitle';
import { use3DGraphDataQuery } from '../../services/api';

const View3D = ({
  defaultActiveFilters,
  defaultDisplay3D,
  graphTypes,
  colorscale,
  minMax,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const activeFilters = useMemo(
    () =>
      JSON.parse(searchParams?.get('activeFilters')) ?? defaultActiveFilters,
    [defaultActiveFilters, searchParams],
  );

  const display3D = useMemo(
    () => JSON.parse(searchParams?.get('display3D')) ?? defaultDisplay3D,
    [defaultDisplay3D, searchParams],
  );

  const { data: graphData, isLoading: loadingGraphData } =
    use3DGraphDataQuery(activeFilters);

  const update3DDisplay = useCallback(
    (label, value) => {
      navigate(
        getNewRoute(location, {
          display3D: {
            ...display3D,
            [label]: value,
          },
        }),
      );
    },
    [display3D, location, navigate],
  );

  if (loadingGraphData && !graphData) {
    return <Loader>Loading filters...</Loader>;
  }

  if (location.pathname.startsWith('/bulletin')) {
    return (
      <div className="GraphView range">
        <Graph3D
          data={graphData}
          loading={loadingGraphData}
          colorscale={colorscale}
          options={{ min: display3D.min, max: display3D.max }}
          minMax={minMax}
          type={display3D.type}
          isExportable
          isCentered={graphData?.centered}
          refString="3d-graph"
        />
      </div>
    );
  }

  return (
    <>
      <ViewTitle pageTitle="depth vs time" />
      <div className="GraphView 3d">
        <Card className="graph">
          <Graph3D
            data={graphData}
            loading={loadingGraphData}
            colorscale={colorscale}
            options={{ min: display3D.min, max: display3D.max }}
            minMax={minMax}
            type={display3D.type}
            isExportable
            isCentered={graphData?.centered}
            refString="3d-graph"
          />
        </Card>
        <Card className="filters">
          <Filters filters={activeFilters?.slice(0, 1)} view="depth-time" />
          <Filter3D
            graphTypes={graphTypes}
            update3DDisplay={update3DDisplay}
            display3D={display3D}
          />
        </Card>
      </div>
    </>
  );
};

export default View3D;
